import { render, staticRenderFns } from "./cityChoice.vue?vue&type=template&id=a5da71be&scoped=true&"
import script from "./cityChoice.vue?vue&type=script&lang=js&"
export * from "./cityChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5da71be",
  null
  
)

export default component.exports